import { render, staticRenderFns } from "./RenderPage.vue?vue&type=template&id=40da7f8c&scoped=true&"
import script from "./RenderPage.vue?vue&type=script&lang=js&"
export * from "./RenderPage.vue?vue&type=script&lang=js&"
import style0 from "./RenderPage.vue?vue&type=style&index=0&id=40da7f8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da7f8c",
  null
  
)

export default component.exports